'use client';

import { type RoadMapUpdate } from '@/domain/roadmap/types';
import { TextField } from '@andritzot/metris-web-ui/inputs/textfield';
import { Box } from '@andritzot/metris-web-ui/layout/content/Box';
import { type Control, Controller } from 'react-hook-form';

import { FieldActionsWrapper } from './shared/FieldActionsWrapper';

interface QualityCertificateFieldProps {
  viewOnly: boolean;
  control: Control<RoadMapUpdate, unknown>;
}

export function QualityCertificateField({ viewOnly, control }: Readonly<QualityCertificateFieldProps>) {
  return (
    <Box sx={{ py: 0.75, width: '100%' }}>
      <Controller
        name="qualityCertificate"
        control={control}
        render={({ field }) => (
          <FieldActionsWrapper copyValue={field.value ?? ''}>
            <TextField
              {...field}
              label="Quality Certificate"
              disabled={viewOnly}
              fullWidth
              size="small"
              placeholder="https://..."
              slotProps={{ htmlInput: { maxLength: 500 } }}
            />
          </FieldActionsWrapper>
        )}
      />
    </Box>
  );
}
